<template>
    <div class="mobile-search-container">
        <div v-show="show_results && components.length > 0"
             id="search-results"
             class="search-results-container"
             ref="resultsContainer"
        >
            <div class="results-header d-flex justify-content-between align-items-center">
                <h5 class="mt-1">Resultados de la búsqueda</h5>
                <b-button variant="link"
                          size="sm"
                          @click="closeResults"
                >
                    <i class="fa fa-close"/>
                </b-button>
            </div>

            <div class="results-scroll-container"
                 ref="scrollContainer"
            >
                <b-list-group>
                    <b-list-group-item v-for="(component, index) in components"
                                       :key="index"
                                       button
                                       :class="{'bg-light' :  index % 2 === 1}"
                                       @dblclick="selectResult(component)"
                    >
                        <b-row>
                            <b-col md="9">
                                <div class="font-weight-bold text-truncate">{{ component.name.toUpperCase() }}</div>
                                <div class="small text-muted">{{ component.cas_number }}</div>
                            </b-col>
                            <b-col>
                                <el-tooltip placement="top">
                                    <div slot="content">
                                        <div>
                                            <div v-for="(item, idx) in component.sga_categories"
                                                 :key="idx"
                                                 class="text-truncate"
                                            >
                                                {{ item.category.codigo }} - {{ item.category.categoria }}
                                            </div>
                                        </div>
                                    </div>

                                    <b-badge :id="'popover-badge-l' + index"
                                             variant="primary"
                                             class="mt-2 p-1"
                                    >
                                        Clasificación SGA ({{ component.sga_categories.length }})
                                    </b-badge>

                                </el-tooltip>
                            </b-col>
                        </b-row>

                    </b-list-group-item>
                </b-list-group>

                <div v-if="components.length > 3"
                     class="scroll-indicator"
                     :class="{ 'hidden': !showScrollIndicator }"
                >
                    <i class="fa fa-chevron-down"/>
                </div>
            </div>

            <div class="text-center pt-1 pb-2"
                 v-if="components.length > 0"
            >
                <small class="text-muted">{{ components.length }} resultado(s) encontrado(s)</small><br>
                <small class="text-muted font-weight-bold">Haga doble click para seleccionar el componente</small>
            </div>
        </div>

        <div v-if="show_results && components.length > 0"
             class="results-overlay"
             @click="closeResults"
        />
    </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name: 'MobileSearch',
    props: {
        show_results: {
            required: true,
            default: false
        }
    },
    data() {
        return {
            showScrollIndicator: true
        };
    },
    computed: {
        ...mapState('calculator', [
            'components',
            'raw_material'
        ])
    },
    methods: {
        closeResults() {
            this.$emit('closeResults');
        },
        selectResult(item) {
            let components = this.raw_material.components;

            if (['NO REPORTADO', 'MEZCLA'].includes(item.cas_number)) {
                if (components.some(c => c.cas_number === item.cas_number && c.name === item.name)) {
                    this.$notify({
                        title: 'Error',
                        message: 'El componente ya existe',
                        type: 'error',
                        duration: 6000
                    });

                    return
                }
            }else {
                if (components.some(c => c.cas_number === item.cas_number)) {
                    this.$notify({
                        title: 'Error',
                        message: 'El componente ya existe',
                        type: 'error',
                        duration: 6000
                    });

                    return
                }
            }

            this.$emit('selectResult', item);
        },
        handleClickOutside(event) {
            const {resultsContainer} = this.$refs;
            if (this.show_results &&
                resultsContainer &&
                !resultsContainer.contains(event.target)
            ) {
                this.closeResults();
            }
        },
        setupScrollListener() {
            const scrollContainer = this.$refs.scrollContainer;

            if (scrollContainer) {
                this.showScrollIndicator = scrollContainer.scrollHeight > scrollContainer.clientHeight;

                scrollContainer.addEventListener('scroll', this.handleScroll);

                this.handleScroll();
            }
        },
        handleScroll() {
            const scrollContainer = this.$refs.scrollContainer;

            if (scrollContainer) {
                const scrollPosition = scrollContainer.scrollTop;
                const scrollHeight = scrollContainer.scrollHeight;
                const containerHeight = scrollContainer.clientHeight;

                const scrollPercentage = scrollPosition / (scrollHeight - containerHeight);

                if (scrollHeight <= containerHeight) {
                    this.showScrollIndicator = false;
                    return;
                }

                this.showScrollIndicator = !(scrollPercentage > 0);
            }
        }
    },
    mounted() {
        this.setupScrollListener();
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside);

        const scrollContainer = this.$refs.scrollContainer;
        if (scrollContainer) {
            scrollContainer.removeEventListener('scroll', this.handleScroll);
        }
    }
};
</script>

<style>
.mobile-search-container {
    position: relative;
    width: 100%;
    z-index: 1000;
}

.search-results-container {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    max-width: 700px;
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 5px 25px rgba(0, 0, 0, 0.2);
    z-index: 1010;
    display: flex;
    flex-direction: column;
}

.results-header {
    padding: 12px 15px;
    border-bottom: 1px solid #eee;
    position: relative;
    flex-shrink: 0;
}

.results-scroll-container {
    position: relative;
    height: calc(3 * 65px);
    overflow-y: auto;
    scrollbar-width: thin;
    padding-bottom: 30px;
}

.results-scroll-container::-webkit-scrollbar {
    width: 6px;
}

.results-scroll-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.results-scroll-container::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
}

.results-scroll-container::-webkit-scrollbar-thumb:hover {
    background: #aaa;
}

.scroll-indicator {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.1));
    padding: 15px 0 5px;
    transition: opacity 0.2s, visibility 0.2s;
    pointer-events: none;
    height: 40px;
    z-index: 5;
}

.scroll-indicator.hidden {
    opacity: 0 !important;
    visibility: hidden;
}

.scroll-indicator i {
    animation: bounce 1.5s infinite;
    color: #666;
}

@keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
        transform: translateY(0);
    }
    40% {
        transform: translateY(-5px);
    }
    60% {
        transform: translateY(-3px);
    }
}

.results-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 1005;
}

.results-header:before {
    content: '';
    position: absolute;
    top: 6px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 4px;
    background-color: #ddd;
    border-radius: 2px;
}

@media (max-width: 768px) {
    .search-results-container {
        width: 95%;
    }
}

@media (max-width: 480px) {
    .search-results-container {
        width: 100%;
    }
}
</style>
